'use client'

import { useEffect } from 'react'

/**
 * This hook is used to remove the pointer-events on the body when a dialog is closed.
 * This is useful to prevent the body from being unresponsive when a dialog is open.
 * This is a workaround for the fact that the body element is not being observed for style changes.
 * This is a known issue with the Dialog component.
 */
export function useRemovePointerEvents() {
  useEffect(() => {
    // Create a MutationObserver to watch for style changes on body
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'style' &&
          document.body.style.pointerEvents === 'none'
        ) {
          // If dialog is closed (no dialog element with data-state="open")
          const openDialog = document.querySelector('[role="dialog"][data-state="open"]')
          if (!openDialog) {
            document.body.style.removeProperty('pointer-events')
          }
        }
      })
    })

    // Start observing the body element
    observer.observe(document.body, {
      attributeFilter: ['style'],
      attributes: true
    })

    // Cleanup observer on unmount
    return () => {
      observer.disconnect()
      document.body.style.removeProperty('pointer-events')
    }
  }, [])
}
